/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate user types in the overall application.
   Developer: Aashish Singh, Created Date: 13-August-2025 
</summary>
*/
enum emailTypeEnum{
    ReservationReminder = 0,
    VisitingThanks = 1,
    HappyBirthday = 2,
    AuthenticationCode = 3,
    RegistrationCompletion = 4,
    ReservationConfirmation = 5,
    RegistrationCancelation = 6,
    PasswordReset = 7,
}

export default emailTypeEnum;